<template>
  <div>

    <div v-if="consultUid == ''">
      Please open the application from <b-link to="/">the start page</b-link>.
    </div>


    <b-container fluid class="registration-form-box mb-2" v-if="consultUid != ''">

      <b-row>
        <b-col cols="12" sm="12" md="4" lg="4" xl="4" >

          <div class="form-section-demographics text-left">


            <b-container class="m-0 p-0">

              <b-row no-gutters>
                <b-col class="p-1" cols="12" sm="12" md="12" lg="12" xl="6">
                  <b-form-group
                    label="First Name"
                    label-for="input-first-name"
                    label-class="reg-form-label">
                    <b-form-input
                      id="input-first-name"
                      v-model="fields.FirstName"
                      maxlength="30"
                      v-bind:class="{'invalid-border': $v.fields.FirstName.$dirty && $v.fields.FirstName.$invalid}"
                      @blur="touchField('FirstName')"
                    ></b-form-input>
                    <div class="invalid-message" v-if="$v.fields.FirstName.$dirty && !$v.fields.FirstName.required">First Name is required</div>
                  </b-form-group>
                </b-col>



                <b-col class="p-1" cols="12" sm="12" md="12" lg="12" xl="6">
                  <b-form-group
                    label="Last Name"
                    label-for="input-last-name"
                    label-class="reg-form-label">
                    <b-form-input
                      id="input-last-name"
                      v-model="fields.LastName"
                      maxlength="30"
                      v-bind:class="{'invalid-border': $v.fields.LastName.$dirty && $v.fields.LastName.$invalid}"
                      @blur="touchField('LastName')"
                    ></b-form-input>
                    <div class="invalid-message" v-if="$v.fields.LastName.$dirty && !$v.fields.LastName.required">Last Name is required</div>
                  </b-form-group>
                </b-col>

              </b-row>
            </b-container>



            <b-container class="m-0 p-0">
              <b-row no-gutters>

                <b-col class="p-1" cols="12" sm="12" md="12" lg="12" xl="6">
                  <b-form-group
                      label="DOB (mm/dd/yyyy)"
                      label-for="input-dob"
                      label-class="reg-form-label">
                    <input-mask
                      id="input-dob"
                      class="form-control"
                      v-model="DOB"
                      mask="99/99/9999"
                      maxlength="12"
                      v-bind:class="{'invalid-border': $v.fields.DOB.$dirty && $v.fields.DOB.$invalid}"
                      @blur="touchAndUpdateField('DOB', DOB)"
                    ></input-mask>
                    <div class="invalid-message" v-if="$v.fields.DOB.$dirty && !$v.fields.DOB.required">DOB is required</div>
                    <div class="invalid-message" v-if="$v.fields.DOB.$dirty && $v.fields.DOB.required && !$v.fields.DOB.validDate">DOB is not valid</div>
                  </b-form-group>
                </b-col>


                <b-col v-if="isNewPatient"
                    class="p-1" cols="12" sm="12" md="12" lg="12" xl="6">
                  <b-form-group
                    label="Place of birth"
                    description="optional"
                    label-for="input-place-of-birth"
                    label-class="reg-form-label">
                      <!-- v-bind:class="{'invalid-border': $v.fields.PlaceOfBirth.$dirty && $v.fields.PlaceOfBirth.$invalid}" -->
                    <b-form-input
                      id="input-place-of-birth"
                      v-model="fields.PlaceOfBirth"
                      placeholder="City, State, Zip"
                      maxlength="100"
                    ></b-form-input>
                    <!-- <div class="invalid-message" v-if="$v.fields.PlaceOfBirth.$dirty && !$v.fields.PlaceOfBirth.required">Place of Birth is required</div> -->
                  </b-form-group>
                </b-col>




                <b-col class="p-1" cols="12" sm="12" md="12" lg="12" xl="6">
                  <b-form-group
                    label="SSN"
                    description="optional"
                    label-for="input-ssn"
                    label-class="reg-form-label">
                    <input-mask
                      id="input-ssn"
                      class="form-control"
                      v-model="SSN"
                      mask="999-99-9999"
                      maxlength="12"
                      v-bind:class="{'invalid-border': $v.fields.SSN.$dirty && $v.fields.SSN.$invalid}"
                      @blur="touchAndUpdateField('SSN', SSN)"
                    ></input-mask>
                    <!-- <div class="invalid-message" v-if="$v.fields.SSN.$dirty && !$v.fields.SSN.required">SSN is required</div> -->
                    <!-- <div class="invalid-message" v-if="$v.fields.SSN.$dirty && $v.fields.SSN.required && !$v.fields.SSN.validSSN">SSN is not valid</div> -->
                    <div class="invalid-message" v-if="$v.fields.SSN.$dirty && !$v.fields.SSN.validSSN">SSN is not valid</div>
                  </b-form-group>
                </b-col>




                <b-col class="p-1" cols="12" sm="12" md="12" lg="12" xl="6">
                  <b-form-group label="Gender"
                    label-class="reg-form-label">
                    <b-form-radio-group v-model="fields.Gender"
                        buttons 
                        :button-variant="invalidRequired('Gender') ? 'outline-danger' : 'outline-secondary'"
                        @change="touchField('Gender')">
                      <b-form-radio value="Male">Male</b-form-radio>
                      <b-form-radio value="Female">Female</b-form-radio>
                      <b-form-radio value="Other">Other</b-form-radio>
                    </b-form-radio-group>
                    <div class="invalid-message" v-if="invalidRequired('Gender')">Gender is required</div>
                  </b-form-group>
                </b-col>



                <b-col v-if="isNewPatient"
                    class="p-1" cols="12" sm="12" md="12" lg="12" xl="6">
                  <b-form-group
                    label="Employer"
                    description="optional"
                    label-for="input-employer"
                    label-class="reg-form-label">
                      <!-- v-bind:class="{'invalid-border': $v.fields.Employer.$dirty && $v.fields.Employer.$invalid}" -->
                    <b-form-input
                      id="input-employer"
                      v-model="fields.Employer"
                      maxlength="100"
                    ></b-form-input>
                    <!-- <div class="invalid-message" v-if="$v.fields.Employer.$dirty && !$v.fields.Employer.required">Employer is required</div> -->
                  </b-form-group>
                </b-col>




                <b-col v-if="isNewPatient"
                    class="p-1" cols="12" sm="12" md="12" lg="12" xl="6">
                  <b-form-group
                    label="Occupation"
                    description="optional"
                    label-for="input-occupation"
                    label-class="reg-form-label">
                      <!-- v-bind:class="{'invalid-border': $v.fields.Occupation.$dirty && $v.fields.Occupation.$invalid}" -->
                    <b-form-input
                      id="input-occupation"
                      v-model="fields.Occupation"
                      maxlength="100"
                    ></b-form-input>
                    <!-- <div class="invalid-message" v-if="$v.fields.Occupation.$dirty && !$v.fields.Occupation.required">Occupation is required</div> -->
                  </b-form-group>
                </b-col>


<!-- providers -->
                <b-col v-if="isNewPatient"
                    class="p-1" cols="12" sm="12" md="12" lg="12" xl="12">
                  <b-form-group
                    label="Referring Provider"
                    description="optional"
                    label-for="input-ref-provider"
                    label-class="reg-form-label">
                    <b-form-input
                      id="input-ref-provider"
                      v-model="fields.ReferringProvider"
                      maxlength="100"
                    ></b-form-input>
                      <!-- v-bind:class="{'invalid-border': $v.fields.ReferringProvider.$dirty && $v.fields.ReferringProvider.$invalid}" -->
                    <!-- <div class="invalid-message" v-if="$v.fields.ReferringProvider.$dirty && !$v.fields.ReferringProvider.required">Occupation is required</div> -->
                  </b-form-group>
                </b-col>



                <b-col v-if="isNewPatient"
                    class="p-1" cols="12" sm="12" md="12" lg="12" xl="6">
                  <b-form-group
                    label="Primary Care Provider"
                    description="optional"
                    label-for="input-primary-care-provider"
                    label-class="reg-form-label">
                    <b-form-input
                      id="input-primary-care-provider"
                      v-model="fields.PrimaryCareProvider"
                      maxlength="100"
                    ></b-form-input>
                      <!-- v-bind:class="{'invalid-border': $v.fields.PrimaryCareProvider.$dirty && $v.fields.PrimaryCareProvider.$invalid}" -->
                    <!-- <div class="invalid-message" v-if="$v.fields.PrimaryCareProvider.$dirty && !$v.fields.PrimaryCareProvider.required">Occupation is required</div> -->
                  </b-form-group>
                </b-col>


                <b-col v-if="isNewPatient"
                    class="p-1" cols="12" sm="12" md="12" lg="12" xl="6">
                  <b-form-group
                    label="PCP Phone"
                    description="optional"
                    label-for="input-primary-care-provider-phone"
                    label-class="reg-form-label">
                    <b-form-input
                      id="input-primary-care-provider-phone"
                      v-model="fields.PrimaryCareProviderPhone"
                      maxlength="100"
                    ></b-form-input>
                      <!-- v-bind:class="{'invalid-border': $v.fields.PrimaryCareProviderPhone.$dirty && $v.fields.PrimaryCareProviderPhone.$invalid}" -->
                    <!-- <div class="invalid-message" v-if="$v.fields.PrimaryCareProviderPhone.$dirty && !$v.fields.PrimaryCareProviderPhone.required">Occupation is required</div> -->
                  </b-form-group>
                </b-col>



            <!-- </b-container>

            <b-container class="m-0 p-0"> -->


                <b-col class="p-1" cols="12">
                  <b-form-group
                    label="Select your dermatologist"
                    label-for="input-consmd"
                    label-class="reg-form-label">

                    <b-form-select v-model="fields.ConsultingMD"
                        id="input-consmd"
                        @change="touchField('ConsultingMD')"
                        @blur.native="touchField('ConsultingMD')"
                        v-bind:class="{'invalid-border': invalidRequired('ConsultingMD')}"
                        >
                      <template v-slot:first>
                        <b-form-select-option :value="undefined">-- Please select an option --</b-form-select-option>
                      </template>

                      <option v-for="(item, index) in consultingMds"
                                :key="'consultingMd_option_' + index"
                                :value="item.name"
                                :class="makeConsultingMdClass(item)"
                                :title="makeConsultingMdTitle(item)">
                        {{makeConsultingMdValue(item)}}
                      </option>                
                    </b-form-select>
                    <div class="invalid-message" v-if="invalidRequired('ConsultingMD')">Consulting Provider is required</div>                  
                  </b-form-group>
                </b-col>

              </b-row>
              <b-row no-gutters>


                <b-col class="p-1" cols="12" sm="12" md="12" lg="12" xl="6">
                  <b-form-group
                    label="E-Mail"
                    label-for="input-email"
                    label-class="reg-form-label">
                    <b-form-input
                      id="input-email"
                      v-model="EMail"
                      maxlength="80"
                      v-bind:class="{'invalid-border': $v.fields.EMail.$dirty && $v.fields.EMail.$invalid}"
                      @blur="touchAndUpdateField('EMail', EMail)"
                    ></b-form-input>
                    <div class="invalid-message" v-if="$v.fields.EMail.$dirty && !$v.fields.EMail.required">E-Mail is required</div>
                    <div class="invalid-message" v-if="$v.fields.EMail.$dirty && $v.fields.EMail.required && !$v.fields.EMail.validEMail">E-Mail is not valid</div>
                  </b-form-group>
                </b-col>
                      <!-- @input="updateField('EMail', EMail)" -->
                      <!-- @change="touchField('EMail')" -->

                <b-col class="p-1" cols="12" sm="12" md="12" lg="12" xl="6">
                  <b-form-group
                    label="Cell Phone"
                    description="optional"
                    label-for="input-day-phone"
                    label-class="reg-form-label">
                    <input-mask
                      id="input-day-phone"
                      class="form-control"
                      v-model="DayPhone"
                      maxlength="15"
                      mask="(999) 999-9999"
                      v-bind:class="{'invalid-border': $v.fields.DayPhone.$dirty && $v.fields.DayPhone.$invalid}"
                      @blur="touchAndUpdateField('DayPhone', DayPhone)"
                    ></input-mask>
                    <div class="invalid-message" v-if="$v.fields.DayPhone.$dirty && !$v.fields.DayPhone.validPhone">Phone number is not valid</div>
                  </b-form-group>
                </b-col>

              </b-row>
            </b-container>

          </div>


        </b-col>


<!-- ############################## -->

        <b-col cols="12" sm="12" md="4" lg="4" xl="4">
          <!-- <div class="form-section-medical text-left"> -->


<!-- class="form-section-medical" -->
          <!-- <div role="tablist"> -->

            <b-card no-body>
              <b-card-header header-tag="header" class="p-0" role="tab">
                <b-button block href="#" v-b-toggle.accordion-present-illness 
                    :variant="invalidPresentIllness() ? 'danger' : 'info'"
                    id="accordion-present-illness-header"
                    :title="accordionMedical['present-illness'] ? 'Click to collapse' : 'Click to expand'"
                  >
                  <div class="section-header-box">
                    <div class="section-header-title">
                      Present Illness
                    </div>
                    <div>
                      <b-icon-chevron-down class="section-header-icon"
                        font-scale="1.5"
                        v-bind:class="{'section-header-icon-rotate': accordionMedical['present-illness']}">
                      </b-icon-chevron-down>
                    </div>
                  </div>
                </b-button>
              </b-card-header>

              <b-collapse id="accordion-present-illness" 
                  v-model="accordionMedical['present-illness']" 
                  role="tabpanel">
                <b-card-body class="accordion-medical-section text-left">

                  <b-form-group
                    label="Reason for your visit today"
                    label-for="input-reason"
                    label-class="reg-form-label">
                    <b-form-input
                      id="input-reason"
                      v-model="fields.ReasonForConsult"
                      maxlength="400"
                      v-bind:class="{'invalid-border': invalidRequired('ReasonForConsult')}"
                      @blur.native="touchField('ReasonForConsult')"
                    ></b-form-input>
                    <div class="invalid-message" v-if="invalidRequired('ReasonForConsult')">Reason for Consult is required</div>
                  </b-form-group>


                  <b-form-group
                      label="Symptoms"
                      label-class="reg-form-label"
                    >
                    <small class="form-text text-muted">
                      (check all that apply)
                    </small>
                    <b-form-checkbox-group
                        v-model="Symptoms"
                        v-bind:class="{'invalid-border-full': $v.fields.Symptoms.$dirty && $v.fields.Symptoms.$invalid}"
                        :options="optionsSymptoms"
                      >
                    </b-form-checkbox-group>
                    <b-form-input
                      v-model="Symptoms_Other"
                      maxlength="200"
                      placeholder="Other symptoms"
                      v-bind:class="{'invalid-border': $v.fields.Symptoms.$dirty && $v.fields.Symptoms.$invalid}"
                      @change="$v.fields.Symptoms.$touch()"
                      @blur="$v.fields.Symptoms.$touch()">
                    </b-form-input>
                    <div class="invalid-message" v-if="$v.fields.Symptoms.$dirty && $v.fields.Symptoms.$invalid">Please check or enter your symptoms</div>                  
                  </b-form-group>


                  <b-form-group
                      label="Areas of your body that are affected"
                      label-class="reg-form-label"
                    >
                    <small class="form-text text-muted">
                      (check all that apply)
                    </small>
                    <b-form-checkbox-group
                        v-model="BodyLocations"
                        :options="optionsBodyLocations"
                        v-bind:class="{'invalid-border-full': $v.fields.BodyLocations.$dirty && $v.fields.BodyLocations.$invalid}">
                    </b-form-checkbox-group>
                    <b-form-input
                      v-model="BodyLocations_Other"
                      maxlength="200"
                      placeholder="Other locations"
                      v-bind:class="{'invalid-border': $v.fields.BodyLocations.$dirty && $v.fields.BodyLocations.$invalid}"
                      @change="$v.fields.BodyLocations.$touch()"
                      @blur="$v.fields.BodyLocations.$touch()">
                    </b-form-input>
                    <div class="invalid-message" v-if="$v.fields.BodyLocations.$dirty && $v.fields.BodyLocations.$invalid">Please check or enter your body locations</div>
                  </b-form-group>


                  <b-form-group
                    label="How long have you had this concern?"
                    label-for="input-duration"
                    label-class="reg-form-label">
                    <b-form-input
                      id="input-duration"
                      v-model="fields.Duration"
                      maxlength="200"
                      v-bind:class="{'invalid-border': invalidRequired('Duration')}"
                      @blur.native="touchField('Duration')"
                    ></b-form-input>
                    <div class="invalid-message" v-if="invalidRequired('Duration')">Duration is required</div>                  
                  </b-form-group>


                  <b-form-group
                      label="Allergies"
                      label-class="reg-form-label"
                    >
                    <small class="form-text text-muted">
                      (check all that apply)
                    </small>
                    <b-form-checkbox-group
                        v-model="Allergies"
                        :options="optionsAllergies"
                        v-bind:class="{'invalid-border-full': $v.fields.Allergies.$dirty && $v.fields.Allergies.$invalid}">
                    </b-form-checkbox-group>
                    <b-form-input
                      v-model="Allergies_Other"
                      maxlength="200"
                      placeholder="Food or other allergies"
                      v-bind:class="{'invalid-border': $v.fields.Allergies.$dirty && $v.fields.Allergies.$invalid}"
                      @change="$v.fields.Allergies.$touch()"
                      @blur="$v.fields.Allergies.$touch()">
                    </b-form-input>
                    <div class="invalid-message" v-if="$v.fields.Allergies.$dirty && $v.fields.Allergies.$invalid">Please check or enter your allergies</div>                  
                  </b-form-group>            



                  <b-form-group
                    label="Oral medications have you tried for this issue"
                    description="optional"
                    label-for="input-MedicationsOral"
                    label-class="reg-form-label">
                    <b-form-input
                      id="input-MedicationsOral"
                      v-model="fields.MedicationsOral"
                      maxlength="400"
                    ></b-form-input>
                  </b-form-group>


                  <b-form-group
                    label="Topical medications have you tried (prescription or OTC)"
                    description="optional"
                    label-for="input-MedicationsTopical"
                    label-class="reg-form-label">
                    <b-form-input
                      id="input-MedicationsTopical"
                      v-model="fields.MedicationsTopical"
                      maxlength="400"
                    ></b-form-input>
                  </b-form-group>


                  <!-- Smoking History for existing patient -->
                  <b-form-group v-if="!isNewPatient"
                      label="Smoking History"
                      label-class="reg-form-label"
                    >
                        <!-- buttons 
                        :button-variant="($v.fields.SmokingHistory.$dirty && $v.fields.SmokingHistory.$invalid) ? 'outline-danger' : 'outline-secondary'" -->
                    <b-form-radio-group v-model="fields.SmokingHistory"
                        v-bind:class="{'invalid-border-full': $v.fields.SmokingHistory.$dirty && $v.fields.SmokingHistory.$invalid}"
                        @change="$v.fields.SmokingHistory.$touch()">
                      <b-form-radio value="Currently everyday smoker">Everyday smoker</b-form-radio>
                      <b-form-radio value="Current occasional smoker">Occassional smoker</b-form-radio>
                      <b-form-radio value="Former smoker">Former smoker</b-form-radio>
                      <b-form-radio value="Never smoker">Never smoker</b-form-radio>
                    </b-form-radio-group>
                    <!-- <div class="invalid-message" v-if="invalidRequired('SmokingHistory')">Please select an option</div> -->
                    <div class="invalid-message" v-if="$v.fields.SmokingHistory.$dirty && !$v.fields.SmokingHistory.required">Please select an option</div>
                  </b-form-group>




                  <div class="text-right">
                    <b-button 
                        @click="collapseSection('present-illness')"
                        size="sm"
                        variant="outline-secondary"
                        title="Collapse Section">
                      <b-icon-chevron-up></b-icon-chevron-up>
                    </b-button>
                  </div>

                </b-card-body>
              </b-collapse>
            </b-card> <!-- Present Illness -->






            <b-card no-body v-if="isNewPatient">
              <b-card-header header-tag="header" class="p-0" role="tab">
                <b-button block href="#" v-b-toggle.accordion-past-medical-history 
                    :variant="invalidPastMedicalHistory() ? 'danger' : 'info'"
                    id="accordion-past-medical-history-header"
                    :title="accordionMedical['past-medical-history'] ? 'Click to collapse' : 'Click to expand'"
                  >
                  <div class="section-header-box">
                    <div class="section-header-title">
                      Past Medical History
                    </div>
                    <div>
                      <b-icon-chevron-down class="section-header-icon"
                        font-scale="1.5"
                        v-bind:class="{'section-header-icon-rotate': accordionMedical['past-medical-history']}">
                      </b-icon-chevron-down>
                    </div>
                  </div>
                </b-button>
              </b-card-header>
                  
              <b-collapse id="accordion-past-medical-history"
                  v-model="accordionMedical['past-medical-history']"
                  role="tabpanel">
                <b-card-body class="accordion-medical-section text-left">

                  <b-form-group
                      label="Medical conditions that you currently have or have had"
                      label-class="reg-form-label">
                        <!-- v-bind:class="{'invalid-border-full': $v.fields.MedicalConditions.$dirty && $v.fields.MedicalConditions.$invalid}" -->
                    <small class="form-text text-muted">
                      (optional, check all that apply)
                    </small>
                    <b-form-checkbox-group
                        v-model="MedicalConditions"
                        :options="optionsMedicalConditions"
                      >
                    </b-form-checkbox-group>
                      <!-- v-bind:class="{'invalid-border': $v.fields.MedicalConditions.$dirty && $v.fields.MedicalConditions.$invalid}"
                      @change="$v.fields.MedicalConditions.$touch()"
                      @blur="$v.fields.MedicalConditions.$touch()" -->
                    <b-form-input
                      v-model="MedicalConditions_Other"
                      maxlength="200"
                      placeholder="Other medical conditions"
                      >
                    </b-form-input>
                    <!-- <div class="invalid-message" v-if="$v.fields.MedicalConditions.$dirty && $v.fields.MedicalConditions.$invalid">Please check or enter your medical conditions</div>                   -->
                  </b-form-group> 


                  <b-form-group
                      label="Surgical procedures that you've had"
                      label-class="reg-form-label">
                        <!-- v-bind:class="{'invalid-border-full': $v.fields.SurgicalProcedures.$dirty && $v.fields.SurgicalProcedures.$invalid}" -->
                    <small class="form-text text-muted">
                      (optional, check all that apply)
                    </small>
                    <b-form-checkbox-group
                        v-model="SurgicalProcedures"
                        :options="optionsSurgicalProcedures"
                      >
                    </b-form-checkbox-group>
                      <!-- v-bind:class="{'invalid-border': $v.fields.SurgicalProcedures.$dirty && $v.fields.SurgicalProcedures.$invalid}"
                      @change="$v.fields.SurgicalProcedures.$touch()"
                      @blur="$v.fields.SurgicalProcedures.$touch()" -->
                    <b-form-input
                      v-model="SurgicalProcedures_Other"
                      maxlength="200"
                      placeholder="Other surgical procedures"
                      >
                    </b-form-input>
                    <!-- <div class="invalid-message" v-if="$v.fields.SurgicalProcedures.$dirty && $v.fields.SurgicalProcedures.$invalid">Please check or enter your surgical procedures</div>                   -->
                  </b-form-group> 

                  <div class="text-right">
                    <b-button 
                        @click="collapseSection('past-medical-history')"
                        size="sm"
                        variant="outline-secondary"
                        title="Collapse Section">
                      <b-icon-chevron-up></b-icon-chevron-up>
                    </b-button>
                  </div>

                </b-card-body>
              </b-collapse>
            </b-card> <!-- Past Medical History -->





            <b-card no-body v-if="isNewPatient">
              <b-card-header header-tag="header" class="p-0" role="tab">
                <b-button block href="#" v-b-toggle.accordion-personal-history
                    :variant="invalidPersonalHistory() ? 'danger' : 'info'"
                    id="accordion-personal-history-header"
                    :title="accordionMedical['personal-history'] ? 'Click to collapse' : 'Click to expand'"
                  >
                  <div class="section-header-box">
                    <div class="section-header-title">
                      Personal History
                    </div>
                    <div>
                      <b-icon-chevron-down class="section-header-icon"
                        font-scale="1.5"
                        v-bind:class="{'section-header-icon-rotate': accordionMedical['personal-history']}">
                      </b-icon-chevron-down>
                    </div>
                  </div>
                </b-button>
              </b-card-header>

              <b-collapse id="accordion-personal-history"
                  v-model="accordionMedical['personal-history']"
                  role="tabpanel">
                <b-card-body class="accordion-medical-section text-left">


                  <b-form-group
                      label="Check any of the following conditions that you have"
                      label-class="reg-form-label">
                        <!-- v-bind:class="{'invalid-border-full': $v.fields.PersonalConditions.$dirty && $v.fields.PersonalConditions.$invalid}" -->
                    <small class="form-text text-muted">
                      (check all that apply)
                    </small>
                    <b-form-checkbox-group
                        v-model="PersonalConditions"
                        :options="optionsPersonalConditions"
                      >
                    </b-form-checkbox-group>
                      <!-- v-bind:class="{'invalid-border': $v.fields.PersonalConditions.$dirty && $v.fields.PersonalConditions.$invalid}"
                      @change="$v.fields.PersonalConditions.$touch()"
                      @blur="$v.fields.PersonalConditions.$touch()" -->
                    <b-form-input
                      v-model="PersonalConditions_Other"
                      maxlength="200"
                      placeholder="Other history conditions"
                      >
                    </b-form-input>
                    <!-- <div class="invalid-message" v-if="$v.fields.PersonalConditions.$dirty && $v.fields.PersonalConditions.$invalid">Please check or enter your personal conditons</div>                   -->
                  </b-form-group> 



                  <b-form-group label="Do you wear sunscreen?"
                    label-class="reg-form-label">
                    <b-form-radio-group v-model="fields.Sunscreen"
                        buttons 
                        :button-variant="($v.fields.Sunscreen.$dirty && $v.fields.Sunscreen.$invalid) ? 'outline-danger' : 'outline-secondary'"
                        @change="$v.fields.Sunscreen.$touch()"
                      >
                      <b-form-radio value="Yes">Yes</b-form-radio>
                      <b-form-radio value="No">No</b-form-radio>
                    </b-form-radio-group>
                    <b-form-input
                      v-show="fields.Sunscreen=='Yes'"
                      class="mt-1"
                      v-model="fields.Sunscreen_Spf"
                      maxlength="50"
                      placeholder="What SPF?"
                    >
                    </b-form-input>
                    <div class="invalid-message" v-if="$v.fields.Sunscreen.$dirty && !$v.fields.Sunscreen.required">Please select an option</div>
                  </b-form-group>



                  <b-form-group label="Do you tan in a tanning salon?"
                    label-class="reg-form-label">
                    <b-form-radio-group v-model="fields.Tan"
                        buttons 
                        :button-variant="($v.fields.Tan.$dirty && $v.fields.Tan.$invalid) ? 'outline-danger' : 'outline-secondary'"
                        @change="$v.fields.Tan.$touch()"
                      >
                      <b-form-radio value="Yes">Yes</b-form-radio>
                      <b-form-radio value="No">No</b-form-radio>
                    </b-form-radio-group>
                    <div class="invalid-message" v-if="$v.fields.Tan.$dirty && !$v.fields.Tan.required">Please select an option</div>
                  </b-form-group>




                  <b-form-group label="Do you have a family history of Melanoma?"
                    label-class="reg-form-label">
                    <b-form-radio-group v-model="fields.FamilyHistoryMelanoma"
                        buttons 
                        :button-variant="($v.fields.FamilyHistoryMelanoma.$dirty && $v.fields.FamilyHistoryMelanoma.$invalid) ? 'outline-danger' : 'outline-secondary'"
                        @change="$v.fields.FamilyHistoryMelanoma.$touch()"
                      >
                      <b-form-radio value="Yes">Yes</b-form-radio>
                      <b-form-radio value="No">No</b-form-radio>
                    </b-form-radio-group>
                    <b-form-input
                      v-show="fields.FamilyHistoryMelanoma=='Yes'"
                      class="mt-1"
                      v-model="fields.FamilyHistoryMelanoma_Relative"
                      maxlength="50"
                      placeholder="Which relative?"
                    >
                    </b-form-input>
                    <div class="invalid-message" v-if="$v.fields.FamilyHistoryMelanoma.$dirty && !$v.fields.FamilyHistoryMelanoma.required">Please select an option</div>
                  </b-form-group>



                  <b-form-group label="Do you have a family history of Basal Cell Carcinoma (BCC) or Squamous Cell Carcinoma (SCC)?"
                    label-class="reg-form-label">
                    <b-form-radio-group v-model="fields.FamilyHistoryCellCarcinoma"
                        buttons 
                        :button-variant="($v.fields.FamilyHistoryCellCarcinoma.$dirty && $v.fields.FamilyHistoryCellCarcinoma.$invalid) ? 'outline-danger' : 'outline-secondary'"
                        @change="$v.fields.FamilyHistoryCellCarcinoma.$touch()"
                      >
                      <b-form-radio value="Yes">Yes</b-form-radio>
                      <b-form-radio value="No">No</b-form-radio>
                    </b-form-radio-group>
                    <b-form-input
                      v-show="fields.FamilyHistoryCellCarcinoma=='Yes'"
                      class="mt-1"
                      v-model="fields.FamilyHistoryCellCarcinoma_Relative"
                      maxlength="50"
                      placeholder="Which relative?"
                    >                      
                    </b-form-input>
                    <div class="invalid-message" v-if="$v.fields.FamilyHistoryCellCarcinoma.$dirty && !$v.fields.FamilyHistoryCellCarcinoma.required">Please select an option</div>
                  </b-form-group>




                  <b-form-group
                    label="Current medications (prescription, OTC and supplements)"
                    description="Please include the medication name, dose, and frequency"
                    label-for="CurrentMedications"
                    label-class="reg-form-label">
                      <!-- v-bind:class="{'invalid-border': $v.fields.CurrentMedications.$dirty && $v.fields.CurrentMedications.$invalid}"
                      @blur="$v.fields.CurrentMedications.$touch()" -->
                    <b-form-input
                      id="CurrentMedications"
                      v-model="fields.CurrentMedications"
                      maxlength="400"
                    ></b-form-input>
                    <!-- <div class="invalid-message" v-if="$v.fields.CurrentMedications.$dirty && !$v.fields.CurrentMedications.required">Please enter your current medications</div> -->
                  </b-form-group>                  
                  


                        <!-- :button-variant="($v.fields.SmokingHistory.$dirty && $v.fields.SmokingHistory.$invalid) ? 'outline-danger' : 'outline-secondary'" -->
                  <b-form-group label="Smoking History"
                    label-class="reg-form-label">
                    <b-form-radio-group v-model="fields.SmokingHistory"
                        v-bind:class="{'invalid-border-full': $v.fields.SmokingHistory.$dirty && $v.fields.SmokingHistory.$invalid}"
                        @change="$v.fields.SmokingHistory.$touch()">
                      <b-form-radio value="Currently everyday smoker">Everyday smoker</b-form-radio>
                      <b-form-radio value="Current occasional smoker">Occassional smoker</b-form-radio>
                      <b-form-radio value="Former smoker">Former smoker</b-form-radio>
                      <b-form-radio value="Never smoker">Never smoker</b-form-radio>
                    </b-form-radio-group>
                    <div class="invalid-message" v-if="$v.fields.SmokingHistory.$dirty && !$v.fields.SmokingHistory.required">Please select an option</div>
                  </b-form-group>
                        <!-- buttons 
                        size="sm" -->


                  <b-form-group label="Alcohol Intake"
                    label-class="reg-form-label">
                        <!-- buttons 
                        size="sm" -->
                        <!-- :button-variant="($v.fields.AlcoholIntake.$dirty && $v.fields.AlcoholIntake.$invalid) ? 'outline-danger' : 'outline-secondary'" -->
                    <b-form-radio-group v-model="fields.AlcoholIntake"
                        v-bind:class="{'invalid-border-full': $v.fields.AlcoholIntake.$dirty && $v.fields.AlcoholIntake.$invalid}"
                        @change="$v.fields.AlcoholIntake.$touch()">
                      <b-form-radio value="None">None</b-form-radio>
                      <b-form-radio value="Less than 1 drink per day">Less than 1 drink per day </b-form-radio>
                      <b-form-radio value="1 to 2 drinks per day ">1 to 2 drinks per day </b-form-radio>
                      <b-form-radio value="3 or more drinks per day ">3 or more drinks per day </b-form-radio>
                    </b-form-radio-group>
                    <div class="invalid-message" v-if="$v.fields.AlcoholIntake.$dirty && !$v.fields.AlcoholIntake.required">Please select an option</div>
                  </b-form-group>



                  <b-form-group label="For patients 65 and older, have you received the Pneumococcal (Pneumovax) vaccine?"
                    label-class="reg-form-label">
                        <!-- :button-variant="invalidRequired('PneumococcalVaccine') ? 'outline-danger' : 'outline-secondary'"
                        @change="touchField('PneumococcalVaccine')" -->
                    <b-form-radio-group v-model="fields.PneumococcalVaccine"
                        buttons 
                        button-variant="outline-secondary"
                      >
                      <b-form-radio value="Yes">Yes</b-form-radio>
                      <b-form-radio value="No">No</b-form-radio>
                    </b-form-radio-group>
                    <!-- <div class="invalid-message" v-if="invalidRequired('PneumococcalVaccine')">Please select an option</div> -->
                  </b-form-group>



                  <b-form-group label="For patients 50 and older, have you received the Shingles (Zostavax) vaccine?"
                    label-class="reg-form-label">
                        <!-- :button-variant="invalidRequired('ShinglesVaccine') ? 'outline-danger' : 'outline-secondary'"
                        @change="touchField('ShinglesVaccine')" -->
                    <b-form-radio-group v-model="fields.ShinglesVaccine"
                        buttons 
                        button-variant="outline-secondary"
                      >
                      <b-form-radio value="Yes">Yes</b-form-radio>
                      <b-form-radio value="No">No</b-form-radio>
                    </b-form-radio-group>
                    <!-- <div class="invalid-message" v-if="invalidRequired('ShinglesVaccine')">Please select an option</div> -->
                  </b-form-group>



                  <b-form-group label="For all patients, have you received the Influenza vaccine this flu season?"
                    label-class="reg-form-label">
                    <b-form-radio-group v-model="fields.InfluenzaVaccine"
                        buttons 
                        :button-variant="invalidRequired('InfluenzaVaccine') ? 'outline-danger' : 'outline-secondary'"
                        @change="touchField('InfluenzaVaccine')">
                      <b-form-radio value="Yes">Yes</b-form-radio>
                      <b-form-radio value="No">No</b-form-radio>
                    </b-form-radio-group>
                    <div class="invalid-message" v-if="invalidRequired('InfluenzaVaccine')">Please select an option</div>
                  </b-form-group>




                  <b-form-group
                      label="Are you currently or have you recently experienced any of the following?"
                      label-class="reg-form-label">
                        <!-- v-bind:class="{'invalid-border-full': $v.fields.RecentConditions.$dirty && $v.fields.RecentConditions.$invalid}" -->
                    <small class="form-text text-muted">
                      (check all that apply)
                    </small>
                    <b-form-checkbox-group
                        v-model="RecentConditions"
                        :options="optionsRecentConditions"
                        >
                    </b-form-checkbox-group>
                      <!-- v-bind:class="{'invalid-border': $v.fields.RecentConditions.$dirty && $v.fields.RecentConditions.$invalid}"
                      @change="$v.fields.RecentConditions.$touch()"
                      @blur="$v.fields.RecentConditions.$touch()" -->
                    <b-form-input
                      v-model="RecentConditions_Other"
                      maxlength="200"
                      placeholder="Other current conditions"
                      >
                    </b-form-input>
                    <!-- <div class="invalid-message" v-if="$v.fields.RecentConditions.$dirty && $v.fields.RecentConditions.$invalid">Please check or enter your surgical procedures</div>                   -->
                  </b-form-group> 


                  <div class="text-right">
                    <b-button 
                        @click="collapseSection('personal-history')"
                        size="sm"
                        variant="outline-secondary"
                        title="Collapse Section">
                      <b-icon-chevron-up></b-icon-chevron-up>
                    </b-button>
                  </div>

                </b-card-body>
              </b-collapse>
            </b-card> <!-- Personal History -->






            <b-card no-body v-if="isNewPatient">
              <b-card-header header-tag="header" class="p-0" role="tab">
                <b-button block href="#" v-b-toggle.accordion-alerts
                    :variant="invalidAlerts() ? 'danger' : 'info'"
                    id="accordion-alerts-header"
                    :title="accordionMedical['alerts'] ? 'Click to collapse' : 'Click to expand'"
                  >
                  <div class="section-header-box">
                    <div class="section-header-title">
                      Alerts
                    </div>
                    <div>
                      <b-icon-chevron-down class="section-header-icon"
                        font-scale="1.5"
                        v-bind:class="{'section-header-icon-rotate': accordionMedical['alerts']}">
                      </b-icon-chevron-down>
                    </div>
                  </div>
                </b-button>
              </b-card-header>

              <b-collapse id="accordion-alerts"
                  v-model="accordionMedical['alerts']"
                  role="tabpanel">
                <b-card-body class="accordion-medical-section text-left">

                  <b-form-group
                    label="Alerts"
                    label-class="reg-form-label">
                    <small class="form-text text-muted">
                      (check all that apply)
                    </small>
                    <b-form-checkbox-group
                        v-model="Alerts"
                        :options="optionsAlerts"
                      >
                    </b-form-checkbox-group>
                        <!-- v-bind:class="{'invalid-border-full': $v.fields.Alerts.$dirty && $v.fields.Alerts.$invalid}" -->
                    <!-- <b-form-input
                      v-model="Alerts_Other"
                      maxlength="200"
                      placeholder="Other alerts"
                      v-bind:class="{'invalid-border': $v.fields.Alerts.$dirty && $v.fields.Alerts.$invalid}"
                      @change="$v.fields.Alerts.$touch()"
                      @blur="$v.fields.Alerts.$touch()">
                    </b-form-input> -->
                    <!-- <div class="invalid-message" v-if="$v.fields.Alerts.$dirty && $v.fields.Alerts.$invalid">Please check or enter your surgical procedures</div>                   -->
                  </b-form-group>


                  <div class="text-right">
                    <b-button 
                        @click="collapseSection('alerts')"
                        size="sm"
                        variant="outline-secondary"
                        title="Collapse Section">
                      <b-icon-chevron-up></b-icon-chevron-up>
                    </b-button>
                  </div>

                </b-card-body>
              </b-collapse>
            </b-card> <!-- Alerts -->



<!-- ! -->

            <!-- <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block href="#" v-b-toggle.accordionMedical1 variant="info">Present Illness</b-button>
              </b-card-header>
              <b-collapse id="accordionMedical1" visible accordion="accordion-medical" role="tabpanel">
                <b-card-body>
                  Present Illness
                </b-card-body>
              </b-collapse>
            </b-card>




            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block href="#" v-b-toggle.accordionMedical2 variant="info">Past Medical History</b-button>
              </b-card-header>
              <b-collapse id="accordionMedical2" accordion="accordion-medical" role="tabpanel">
                <b-card-body>
                  Present Illness
                </b-card-body>
              </b-collapse>
            </b-card>





            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block href="#" v-b-toggle.accordionMedical3 variant="info">Personal History</b-button>
              </b-card-header>
              <b-collapse id="accordionMedical3" accordion="accordion-medical" role="tabpanel">
                <b-card-body>
                  Personal History
                </b-card-body>
              </b-collapse>
            </b-card>






            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block href="#" v-b-toggle.accordionMedical4 variant="info">Alerts</b-button>
              </b-card-header>
              <b-collapse id="accordionMedical4" accordion="accordion-medical" role="tabpanel">
                <b-card-body>
                  Alert
                </b-card-body>
              </b-collapse>
            </b-card> -->

          <!-- </div>  -->
          <!-- tablist -->









 
          <!-- </div> -->
        </b-col>



        <!-- <b-col cols="12" sm="12" md="4" lg="4" xl="4">
          <div class="form-section-medical text-left">
            <div class="section-title">Past Medical History</div>

          </div>
        </b-col>


        <b-col cols="12" sm="12" md="4" lg="4" xl="4">
          <div class="form-section-medical text-left">
            <div class="section-title">Personal History</div>

          </div>
        </b-col>



        <b-col cols="12" sm="12" md="4" lg="4" xl="4">
          <div class="form-section-medical text-left">
            <div class="section-title">Alerts</div>

          </div>
        </b-col> -->

<!-- UPLOAD BOX -->

        <b-col cols="12" sm="12" md="4" lg="4" xl="4">
          <div class="form-section-upload text-center">

            <b-form-group
              label="Photo taken by"
              label-for="input-photo-taken-by"
              label-class="reg-form-label"
              class="ml-2 mr-2 text-left">

              <b-form-select v-model="fields.PhotoTakenBy"
                  id="input-photo-taken-by"
                  @change="touchField('PhotoTakenBy')"
                  @blur.native="touchField('PhotoTakenBy')"
                  v-bind:class="{'invalid-border': invalidRequired('PhotoTakenBy')}"
                  >
                <template v-slot:first>
                  <b-form-select-option :value="undefined">-- Please select an option --</b-form-select-option>
                </template>

                <option v-for="(item, index) in optionsPhotoTakenBy"
                          :key="'photo_taken_option_' + index"
                          :value="item"
                          :class="makeConsultingMdClass(item)"
                          :title="makeConsultingMdTitle(item)">
                  {{item}}
                </option>                
              </b-form-select>
              <div class="invalid-message" v-if="invalidRequired('PhotoTakenBy')">Please select an option</div>                  
            </b-form-group>

            <label class="align-center">Upload up to 5 photos</label>

            <UploadBox :consultUid="consultUid"/>
    
            <b-button @click="validateData" 
                :disabled="disabledSubmit"
                size="lg"
                variant="success" 
                class="mt-1 mb-3">
              Submit
            </b-button>
          </div>
        </b-col>

      </b-row>

    </b-container>



    
<!-- modals -->

<!-- @hide="callbackClosedModalInvalidData" -->
    <b-modal v-model="modalInvalidData"
        ok-only
        title="Invalid Data">
      Please correct the data or fill in the required fields.
    </b-modal>


    <b-modal v-model="modalConfirmSubmission"
        title="Confirmation"
        @ok="uploadConsult">
      Are you ready to submit your consult request?
    </b-modal>


    <b-modal v-model="modalUploadInProgress"
        class="text-center"
        no-close-on-backdrop
        no-close-on-esc
        ok-only
        ok-title="Cancel Upload"
        @ok="cancelUpload">
      <div class="text-center">
        <!-- <font-awesome-icon icon="circle-notch" class="spin-icon fa-spin align-middle text-primary" /> -->
        <!-- <b-icon icon="gear" animation="spin" font-scale="4" class="align-middle"></b-icon> -->
        <b-icon-gear animation="spin" font-scale="4" class="align-middle"></b-icon-gear>
        <br />
        <br />
        The consult request is being uploaded, please wait.
      </div>
      <template slot="modal-header">
        <span class="title-case-uploaded">Uploading...</span>
      </template>
    </b-modal>


    <b-modal v-model="modalUploadComplete"
        title="Case Uploaded"
        ok-only
        @hide="uploadDone">
      Case {{accessionNumber}} is submitted. You will be contacted by your dermatology office once your case has been reviewed.
    </b-modal>

    <b-modal v-model="modalUploadError"
        title="Upload Error"
        ok-only>
      {{errorMessage}}
      <br />
      You can reload the page and retry.
    </b-modal>

  </div>
</template>





<script>
import Vue from 'vue';
import axios from 'axios';
import { BLink, BIconGear, BIconChevronUp, BIconChevronDown } from 'bootstrap-vue';

import {debug, defineString, makeCombinedValue, isElementInViewport} from './globals.js';
import UploadBox from './UploadBox';

import InputMask from 'vue-input-mask';

// minLength, between
import { required } from 'vuelidate/lib/validators';



// Vue.component(InputMask);


// for ability to cancel the consult upload request
let CancelToken, CancelTokenSource;



const regexpSsn = /^\d{3}-\d{2}-\d{4}$/,
  regexpEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  regexpPhone = /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/;



// function validF(val) {
//   if (val && val.indexOf('5') >= 0) {
//     return true
//   } else {
//     return false
//   }
// }

// ####################################################################################

function validDate(val) {
  debug('validDate ' + val);
// invalidDate() {
  // var z = 1;
  // if (z == 1) return;

  // utility functions
  function validYear(year) {
    return (year >= 1890 && year < 2100) ? true : false;
  }

  function validMonth(month) {
    return (month >= 1 && month <= 12) ? true : false;
  }

  function validDay(year, month, day) {
    if (month==2 && day>daysInFebruary(year)) {
      return false;
    }
    if (day > daysInMonth(month) ) {
      return false;
    }
    return true;
  }

  function daysInFebruary(year) {
    // February has 29 days in any year evenly divisible by four,
    // EXCEPT for centurial years which are not also divisible by 400.
    return (((year % 4 == 0) && ( (!(year % 100 == 0)) || (year % 400 == 0))) ? 29 : 28 );
  }

  function daysInMonth(m) {
    if (m==4 || m==6 || m==9 || m==11) return 30;
    if (m==2) return 29;
    return 31;
  }

  // end utility funcitons


  // const now = new Date();
  // const yearNow = now.getFullYear();
  // const monthNow = now.getMonth() + 1;
  // const dayNow = now.getDate();


  const date = defineString(val);
  debug('validDate: date=' + date);

  if (date == '' || date == '__/__/____') return true;


  var month = parseInt(date.substr(0, 2)),
    day = parseInt(date.substr(3, 2)),
    year = parseInt(date.substr(6, 4));
  if (isNaN(month) || isNaN(day) || isNaN(year)) {
    debug('validDate: isNaN');
    return false;
  }

  if (!validYear(year)) {
    debug('validDate: invalidYear');
    return false;
  }

  if (!validMonth(month)) {
    debug('validDate: invalidMonth');
    return false;
  }

  if (!validDay(year, month, day)) {
    debug('validDate: invalidDay');
    return false;
  }

  // ok
  return true;

  // function dobYearTooOld(yearNow, year) {
  //   if (year < yearNow-130) {
  //     return true
  //   } else {
  //     return false
  //   }
  // }


  // function dobTooYoung(yearNow, monthNow, dayNow, year, month, day) {
  //   if (year > yearNow) {
  //     // future year
  //     return true
  //   } 

  //   if (year == yearNow) {
  //     // this year => check day and month
  //     if (month > monthNow) {
  //       return true
  //     }
  //     if (month == monthNow && day > dayNow) {
  //       return true
  //     }
  //   }

  //   // not a future year or a future date in this year
  //   return false
  // }

}


function validSSN(val) {
  const ssn = defineString(val);
  if (ssn == '' || ssn == '___-__-____') {
    return true
  }
  
  return regexpSsn.test(ssn);
}


function validEMail(val) {
  const email = defineString(val);
  if (email == '') {
    return true
  }
  
  return regexpEmail.test(email);
}


function validPhone(val) {
  const phone = defineString(val);
  if (phone == '' || phone == '(___) ___-____') {
    return true
  }
  
  return regexpPhone.test(phone);
}




// function validSymptoms(val, vm) {
//   return (makeCombinedValue(vm.Symptoms, vm.Symptoms_Other) != '') ? true : false;
// }

// function validBodyLocations(val, vm) {
//   return (makeCombinedValue(vm.BodyLocations, vm.BodyLocations_Other) != '') ? true : false;
// }

// function validAllergies() {
//   return (makeCombinedValue(vm.Allergies, vm.Allergies_Other) != '') ? true : false;
// }

// ####################################################################################




export default {
  name: 'RegistrationForm',

  components: {
    UploadBox,
    InputMask,
    BLink,
    BIconGear,
    BIconChevronUp,
    BIconChevronDown
  },


  props: {
    isNewPatient: Boolean
  },


  validations() {
    debug('dermatology/Main validations');

    // important note: if validation is used on a specific tab,
    // then the corresponing data or computed field must be defined 
    // to make vuelidation work, e.g.
    // data: { tabs: {} }
    // this.tabs.Demographics = {} etc.

    var v = {};

    v.fields = {};

    v.fields.LastName = { required };
    v.fields.FirstName = { required };

    // v.fields.DOB = { required };
    // v.fields.SSN = { required };
    v.fields.DOB = { required, validDate };
    v.fields.SSN = { validSSN };

    v.fields.Gender = { required };
    v.fields.EMail = { required, validEMail };
    v.fields.DayPhone = { validPhone };

    v.fields.ConsultingMD = { required };
    v.fields.ReasonForConsult = { required };

    // v.fields.Symptoms = { required };
    // v.fields.Symptoms_Other = { required }; // ??
    v.fields.Symptoms = { required };

    
    // v.fields.BodyLocations = { required };
    // v.fields.BodyLocations_Other = { required }; // ??
    v.fields.BodyLocations = { required };

    v.fields.Duration = { required };
    
    // v.fields.Allergies = { required };
    // v.fields.Allergies_Other = { required }; // ??
    v.fields.Allergies = { required };
    
    // v.fields.CurrentMedications = { required };

    v.fields.SmokingHistory = { required };

    v.fields.PhotoTakenBy = { required };


    if (this.isNewPatient) {
      // fields available fornew patient only

      // demographics
      // v.fields.PlaceOfBirth = { required };
      // v.fields.Employer = { required };
      // v.fields.Occupation = { required };

      // // past medical history
      // v.fields.MedicalConditions = { required };
      // v.fields.SurgicalProcedures = { required };

      // personal history
      // v.fields.PersonalConditions = { required };
      // v.fields.RecentConditions = { required }; // ?
      v.fields.Sunscreen = { required };
      v.fields.Tan = { required };
      v.fields.FamilyHistoryMelanoma = { required };
      v.fields.FamilyHistoryCellCarcinoma = { required };
      // v.fields.CurrentMedications = { required };

      v.fields.AlcoholIntake = { required };
      // v.fields.PneumococcalVaccine = { required };
      // v.fields.ShinglesVaccine = { required };
      v.fields.InfluenzaVaccine = { required };
    }



    return v

  },


  computed: {
    consultingMds() {
      return this.$store.getters['config/consultingMds']
    },

    consultUid() {
      return this.$store.getters['form/consultUid']
    },

    accessionNumber() {
      return this.$store.getters['form/accessionNumber'] // use the form store!!!
    },
  },



  data() {
    return {
      canHandleCollapseEvent: false,

      fields: {},

      accordionMedical: {'present-illness': true,
        'past-medical-history': true,
        'personal-history': true,
        'alerts': true,
      },

      FirstName: '',
      LastName: '',
      DOB: '',
      SSN: '',
      EMail: '',
      DayPhone: '',

      Symptoms: [],
      Symptoms_Other: '',

      BodyLocations: [],
      BodyLocations_Other: '',

      Allergies: [],
      Allergies_Other: '',

      MedicalConditions: [],
      MedicalConditions_Other: '',

      SurgicalProcedures: [],
      SurgicalProcedures_Other: '',

      PersonalConditions: [],
      PersonalConditions_Other: '',

      RecentConditions: [],
      RecentConditions_Other: '',

      Alerts: [],



      modalInvalidData: false,
      modalConfirmSubmission: false,
      modalUploadInProgress: false,
      modalUploadComplete: false,
      modalUploadError: false,
      errorMessage: '',
      disabledSubmit: false,

      optionsSymptoms: [
        'Pain',
        'Itch',
        'Bleeding',
        'Enlargement',
        'Spreading',
        'Burning',
        'Redness',
        'Embarrassment',
        'Blistering',
        // 'Other'
      ],
      optionsBodyLocations: [
        'Head',
        'Face',
        'Neck',
        'Body',
        'Arms',
        'Legs',
        'Feet',
        // 'Other'
      ],
      optionsAllergies: ['None',
        'Aspirin',
        'Antibiotics (Penicillin, Tetracycline)',
        'Carbamazepine',
        'Latex',
        'Nonsteroidal anti-inflammatory drugs (Ibuprofen)',
        'Sulfa drugs',
        {text:'Food, specify below', value:'Food'},
        // 'Other',
      ],

      optionsMedicalConditions: [
        'Anxiety',
        'Arthritis',
        'Asthma',
        'Atrial Fibrillation',
        'Benign Prostatic Hyperplasia (BPH)',
        'Bone Marrow Transplant',
        'Breast Cancer',
        'Colon Cancer',
        'COPD',
        'Coronary Artery Disease',
        'Diabetes',
        'Depression',
        'End Stage Renal Disease',
        'Esophageal Reflux (GERD)',
        'Hearing Loss',
        'Hepatitis',
        'High Blood Pressure',
        'HIV/AIDS',
        'HighCholesterol',
        'Hypertension',
        'Hypercholesterolemia',
        'Hypothyroidism',
        'Hyperthyroidism',
        'Leukemia',
        'Lung Cancer',
        'Lymphoma',
        'Prostate Cancer',
        'Radiation Treatment',
        'Seizures',
        'Stroke',
        'Transplant',
      ],

      optionsSurgicalProcedures: [
        'Appendix (Appendectomy)',
        'Bladder (Cystectomy)',
        'Breast: Breast Biopsy',
        'Breast: Lumpectomy (Right / Left / Bilateral)',
        'Breast: Mastectomy (Right / Left / Bilateral)',
        'Colon (Colectomy): Colon Cancer Resection',
        'Colon (Colectomy): Diverticulitis',
        'Colon (Colectomy): Inflammatory Bowel Disease',
        'Colon: Colostomy Gallbladder (Cholecystectomy)',
        'Heart: Coronary Artery Bypass Surgery (CABG)',
        'Heart: Heart Transplant',
        'Heart: Mechanical Valve Replacement',
        'Heart: PTCA',
        'Joint Replacement: Hip (Right / Left / Bilateral)',
        'Joint Replacement: Knee (Right / Left / Bilateral)',
        'Kidney: Kidney Biopsy',
        'Kidney: Kidney Stone Removal',
        'Kidney: Kidney Transplant',
        'Kidney: Nephrectomy',
        'Liver: Hepatectomy',
        'Liver: Liver Transplant',
        'Liver: Shunt Ovaries (Oophorectomy): Endometriosis',
        'Ovaries (Oophorectomy): Ovarian Cancer',
        'Ovaries (Oophorectomy): Ovarian Cyst',
        'Ovaries: Tubal ligation',
        'Pancreas: Pancreatectomy',
        'Prostate (Prostatectomy): Prostate Biopsy',
        'Prostate (Prostatectomy): Prostate Cancer',
        'Prostate (Prostatectomy): TURP',
        'Rectum: Abdominal Perineal Resection (APR)',
        'Rectum: Lower Anterior Resection',
        'Skin: Basal Cell Carcinoma',
        'Skin: Melanoma Skin:',
        'Skin Biopsy',
        'Skin: Squamous Cell Carcinoma Spleen (Splenectomy)',
        'Testicles (Orchiectomy)',
        'Uterus (Hysterectomy): Fibroids',
        'Uterus (Hysterectomy): Uterine Cancer',
        'Uterus (Hysterectomy): Cervical Cancer',
      ],

      optionsPersonalConditions: [
        'Acne',
        'Actinic Keratoses (Precancers)',
        'Asthma',
        'Basal Cell Carcinoma',
        'Blistering',
        'Sunburns',
        'Dry Skin',
        'Eczema',
        'Flaking or Itchy Scalp',
        'Melanoma',
        'Hay Fever/Allergies',
        'Poison Ivy',
        'Precancerous Moles',
        'Psoriasis',
        'Squamous Cell Carcinoma',
      ],

      optionsRecentConditions: [
        'Diarrhea',
        'Fatigue',
        'Unintentional Weight Loss',
        'Pain/Burning on Urination',
        'Nausea',
        'Night Sweats',
        'Weight Gain',
        'New Onset of Joint Aches',
        'Vomiting',
        'Cough',
        'Depression',
        'Numbness/Weakness',
        'Fever or Chills',
        'Shortness of Breath',
        'Anxiety',
      ],

      optionsAlerts: [
        'Allergy to Adhesive',
        'Allergy to Lidocaine',
        'Allergy to Topical Antibiotic Ointment',
        'Artificial Heart Valve',
        'Artificial Joint within the past 2 years',
        'Blood Thinners',
        'Defibrillator',
        'Pacemaker',
        'MRSA',
        'Premedication to Prior Procedures',
        'Rapid Heartbeat with Epinephrine',
        'Pregnant',
        'Planning Pregnancy',
        'Breastfeeding',
      ],

      optionsPhotoTakenBy: [
        'patient without assistance',
        'patient guided by primary care staff (nurse, assistant)',
        'patient guided by dermatologist',
        'dermatology nurse or assistant',
        'dermatologist'
      ],

    }
  },



  mounted() {
    this.fields.PatientType = this.isNewPatient ? 'new' : '';
  },


  methods: {
    touchAndUpdateField(fieldName, newValue) {
      debug('touchAndUpdateField ' + newValue);
      Vue.set(this.fields, fieldName, newValue);
      this.$v.fields[fieldName].$touch()
    },

    updateField(fieldName, newValue) {
      // update field only if input is touched
      // if (this.$v.fields[fieldName].$dirty) {
      //   Vue.set(this.fields, fieldName, newValue);
      // }
      this.$v.fields[fieldName].$touch();
      Vue.set(this.fields, fieldName, newValue);
    },


    updateField2(fieldName, newValue) {
      this.$v.fields[fieldName].$touch();
      Vue.set(this.fields, fieldName, newValue);
    },


    updateCombinedField(fieldName, arrFieldValue, strFieldValue) {
      if (this.$v.fields[fieldName]) {
        this.$v.fields[fieldName].$touch();
      }
      Vue.set(this.fields, fieldName, makeCombinedValue(arrFieldValue, strFieldValue));
    },


    
    touchField(fieldName) {
      if (this.$v.fields[fieldName] != undefined) {
        debug('touchField ' + fieldName);
        this.$v.fields[fieldName].$touch()
      }
    },

    touchField2(fieldName) {
      if (this.$v[fieldName] != undefined) {
        debug('touchField ' + fieldName);
        this.$v[fieldName].$touch()
      }
    },


    invalidRequired(fieldName) {
      return this.$v.fields[fieldName] != undefined
        && this.$v.fields[fieldName].$dirty && !this.$v.fields[fieldName].required;
    },
    

    invalidRequired2(fieldName) {
      return this.$v[fieldName] != undefined
        && this.$v[fieldName].$dirty && !this.$v[fieldName].required;
    },


    // validDate(fieldName) {
    //   debug('validDate ' + fieldName);
    //   return false;
    //   // return !this.invalidDate(fieldName)
    // },




    // invalidDobYearTooOld() {
    //   const dob = defineString(this.fields.DOB);
    //   var year = parseInt(dob.substr(6, 4));
    //   if (!isNan(year)) {
    //     const now = new Date();
    //     const yearNow = now.getFullYear();

    //     if (year < yearNow-130) {
    //       return true
    //     }
    //   }
    //   return false
    // },


    // validateDobYearYoungEnough(year) {
    //   const dob = defineString(this.fields.DOB);
    //   var month = parseInt(dob.substr(0, 2)),
    //     day = parseInt(dob.substr(3, 2)),
    //     year = parseInt(dob.substr(6, 4));
    //   if (isNaN(month) || isNan(day) || isNan(year)) {
    //     debug('invalidDate: isNan');
    //     return false;
    //   }


    //   const now = new Date();
    //   const yearNow = now.getFullYear();
    //   const monthNow = now.getMonth() + 1;
    //   const dayNow = now.getDate();

    //   if (year > yearNow) {
    //     // future year
    //     return false
    //   } 

    //   if (year == yearNow) {
    //     // this year => check day and month
    //     const day = defineString(this.fields['DOB_day']);
    //     const month = defineString(this.fields['DOB_month']);

    //     if (month > monthNow) {
    //       // return [tri18n('The date cannot be a future date, please correct.'), 'month'];
    //       return false
    //     }

    //     if (month == monthNow && day > dayNow) {
    //       // return [tri18n('The date cannot be a future date, please correct.'), 'day'];
    //       return false
    //     }
    //   }

    //   // not a future year or a future date in this year
    //   return true
    // },




   


    makeConsultingMdValue(cmd) {
      const avail_state = defineString(cmd.avail_state);
      if (avail_state == 'closed') {
        return '[x] ' + cmd.full_name + ' (Closed)'
      }
      if (avail_state == 'out') {
        return '[!] ' + cmd.full_name + ' (Out of Office)'
      }
      return cmd.full_name
    },


    makeConsultingMdClass(cmd) {
      const avail_state = defineString(cmd.avail_state);
      if (avail_state == 'closed') {
        return 'option-red'
      }
      if (avail_state == 'out') {
        return 'option-orange'
      }
      return ''
    },


    makeConsultingMdTitle(cmd) {
      const avail_text = defineString(cmd.avail_text);
      return cmd.name + '\n' + cmd.full_name + '\n' + avail_text
    },



    requiredLabel() {
      return false
    },


    validateData() {
      // trim all values
      for (var f in this.fields) {
        const v = defineString(this.fields[f]);
        debug('validateData: [' + f + '] = [' + v + ']');
        this.fields[f] = v.trim();
      }

      this.$v.$touch();
      if (this.$v.$invalid) {
        this.modalInvalidData = true;
        return;
      }

      // confirm
      this.modalConfirmSubmission = true;
    },



    uploadConsult() {
      // saveDataProceed
      debug('RegistrationForm uploadConsult');

      this.disabledSubmit = true;

      this.modalUploadInProgress = true;
      // const vm = this;

      let params = {};
      // params.userProps = this.$store.getters['config/userProps'];
      // params.basicSettings = this.$store.getters['config/basicSettings'];
      // params.draft = this.saveType;
      // debug('RegistrationForm uploadConsult: user=' + params.userProps['userName']);

      this.fields.suid = this.consultUid;
      params.fields = this.fields;


      // token to cancel the request
      CancelToken = axios.CancelToken;
      CancelTokenSource = CancelToken.source();
      params.cancelToken = CancelTokenSource.token;

      
      this.$store.dispatch('form/uploadConsultData', params)
        .then(response => {
          debug('TabsContainer uploadConsult: uploaded: ' + JSON.stringify(response))

          // alert('OK');
          debug('accessionNumber 2 =' + this.accessionNumber);

          // // show uploaded case info
          // this.newCaseSummary = response.data;
          // this.newCaseSummary.timestamp = new Date().toLocaleString();

          this.modalUploadInProgress = false;
          // this.modalUploadComplete = true;

          this.$router.replace('/done');

          // this.modalUploadInProgress = false;
          // this.modalCaseUploaded = true
        }, error => {
          console.error('TabsContainer uploadConsult: form/uploadConsultData: ' + JSON.stringify(error));
          // this.modalUploadInProgress = false;

          console.error('TabsContainer uploadConsult ----------- ERROR');

          if (axios.isCancel(error)) {
            debug('TabsContainer uploadConsult: >>>>>>>>>> Request canceled: ' + error.message);
            this.errorMessage = error.message;
          } else {
            // handle error
            // alert("Error")

            // alert('uploadConsult\n' + error)
            // const err = defineString(error.message);

            var error_msg;
            if (error.data != undefined) {
              error_msg = defineString(error.data.error);
            } else {
              error_msg = defineString('Request failed.');
            }
            debug('TabsContainer saveDataProceed: error_msg=' + error_msg);

            this.errorMessage = error_msg

          }
          this.modalUploadError = true;
          this.disabledSubmit = false;
        })
    },


    cancelUpload() {
      debug('TabsContainer cancelUpload');
      if (CancelTokenSource) {
        CancelTokenSource.cancel('Operation canceled by the user. '
          + 'This can result in data inconsistency.');
      } else {
        debug('Error: CancelTokenSource is not defined');
      }
    },



    uploadDone() {
      // alert('done')
      // try {
        // window.close()
        // setTimeout(window.close, 333);
        this.$router.replace('/done');
      // }
      // catch(e) {
      //   window.location.replace(makeServerUrl('/'));
      // }
    },




    invalidPresentIllness() {
      return this.$v.fields.$dirty && (false 
        || this.$v.fields.ReasonForConsult.$invalid
        || this.$v.fields.Symptoms.$invalid
        || this.$v.fields.BodyLocations.$invalid
        || this.$v.fields.Duration.$invalid
        || this.$v.fields.Allergies.$invalid
        || (!this.isNewPatient && this.$v.fields.SmokingHistory.$invalid)        
      )
    },


    invalidPastMedicalHistory() {
      return false
      // return this.$v.fields.$dirty && (false 
      //   || this.$v.fields.MedicalConditions.$invalid
      //   || this.$v.fields.SurgicalProcedures.$invalid
      // )
    },


    invalidPersonalHistory() {
      return this.$v.fields.$dirty && (false 
        // || this.$v.fields.PersonalConditions.$invalid
        || this.$v.fields.Sunscreen.$invalid
        || this.$v.fields.Tan.$invalid
        || this.$v.fields.FamilyHistoryMelanoma.$invalid
        || this.$v.fields.FamilyHistoryCellCarcinoma.$invalid
        // || this.$v.fields.CurrentMedications.$invalid
        || this.$v.fields.SmokingHistory.$invalid
        || this.$v.fields.AlcoholIntake.$invalid
        // || this.$v.fields.PneumococcalVaccine.$invalid
        // || this.$v.fields.ShinglesVaccine.$invalid
        || this.$v.fields.InfluenzaVaccine.$invalid
        // || this.$v.fields.RecentConditions.$invalid
      )
    },


    invalidAlerts() {
      return false
      // return $v.fields.$dirty && (false
      //   || $v.fields.Alerts.$invalid
      // )
    },


    collapseSection(sectionName) {
      this.accordionMedical[sectionName] = false;

      // debug('collapseSection: ID=' + collapseId + ', isJustShown=' + isJustShown);
      const headerId = 'accordion-' + sectionName + '-header';
      const el = document.getElementById(headerId);
      if (el) {
        Vue.nextTick(function() {
          window.setTimeout(function() {
            const vis = isElementInViewport(el);
            debug('>>>>> found ' + headerId + ' visible=' + vis);
            if (!vis) {
              el.scrollIntoView()
            }
          }, 500);
        });
      }
    }



  },



  watch: {
    FirstName(newValue) {
      this.updateField('FirstName', newValue)
    },

    LastName(newValue) {
      this.updateField('LastName', newValue)
    },

    SSN(newValue) {
      this.updateField('SSN', newValue)
    },

    // DOB(newValue) {
    //   debug('watch DOB: ' + newValue);
    //   this.updateField('DOB', newValue)
    // },


    Symptoms(newValue) {
      this.updateCombinedField('Symptoms', newValue, this.Symptoms_Other)
    },
    Symptoms_Other(newValue) {
      this.updateCombinedField('Symptoms', this.Symptoms, newValue)
    },


    BodyLocations(newValue) {
      this.updateCombinedField('BodyLocations', newValue, this.BodyLocations_Other)
    },
    BodyLocations_Other(newValue) {
      this.updateCombinedField('BodyLocations', this.BodyLocations, newValue)
    },


    Allergies(newValue) {
      this.updateCombinedField('Allergies', newValue, this.Allergies_Other)
    },
    Allergies_Other(newValue) {
      this.updateCombinedField('Allergies', this.Allergies, newValue)
    },


    MedicalConditions(newValue) {
      this.updateCombinedField('MedicalConditions', newValue, this.MedicalConditions_Other)
    },
    MedicalConditions_Other(newValue) {
      this.updateCombinedField('MedicalConditions', this.MedicalConditions, newValue)
    },


    SurgicalProcedures(newValue) {
      this.updateCombinedField('SurgicalProcedures', newValue, this.SurgicalProcedures_Other)
    },
    SurgicalProcedures_Other(newValue) {
      this.updateCombinedField('SurgicalProcedures', this.SurgicalProcedures, newValue)
    },


    PersonalConditions(newValue) {
      this.updateCombinedField('PersonalConditions', newValue, this.PersonalConditions_Other)
    },
    PersonalConditions_Other(newValue) {
      this.updateCombinedField('PersonalConditions', this.PersonalConditions, newValue)
    },


    RecentConditions(newValue) {
      this.updateCombinedField('RecentConditions', newValue, this.RecentConditions_Other)
    },
    RecentConditions_Other(newValue) {
      this.updateCombinedField('RecentConditions', this.RecentConditions, newValue)
    },

    Alerts(newValue) {
      this.updateCombinedField('Alerts', newValue, '')
    },

  }
}
</script>



<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.invalid-message {
  color: red;
}

.invalid-border {
  border-color: red;
}

.invalid-border-full {
  border: thin solid red;
  border-radius: 5px;
}


.form-section-demographics {
  padding: 5px;
  /* margin: 5px; */
  background-color: rgb(219, 234, 235);
  border: thin solid lightgray;
  border-radius: 5px;
}

.form-section-medical {
  /* padding: 10px; */
  margin: 5px;
  background-color: rgb(219, 234, 235);
  border: thin solid lightgray;
}

.accordion-medical-section {
  background-color: rgb(219, 234, 235);
  padding: 10px;
}


.form-section-upload {
  padding: 5px;
  background-color: rgb(219, 234, 235);
  border: thin solid lightgray;
  border-radius: 5px;
}


.section-title {
  text-align: right;
}


.b1 {
  border: thin solid blue;
}

.option-red {
  color:red
}

.option-orange {
  color:orange
}

/deep/ .reg-form-label {
  margin-bottom: 0;
  font-size: 1.2em;
}


/deep/ .col-form-label {
  padding-bottom: 0;
}


/deep/ .form-group small {
  margin-top: 0;
}

/* narrow screen: make checkboxes and radios sparser */
@media (max-width: 767px) {
  /deep/ div.custom-checkbox .custom-control-label {
    padding-bottom: 20px;
  }

  /deep/ div.custom-radio .custom-control-label {
    padding-bottom: 20px;
  }
}


.section-header-box {
  display: flex;
}

.section-header-title {
  flex-grow: 100;
}

.section-header-icon {
  -webkit-transition-duration: 0.5s;
  -moz-transition-duration: 0.5s;
  -o-transition-duration: 0.5s;
  transition-duration: 0.85;  
}

.section-header-icon-rotate {
  -webkit-transform: rotate(180deg);
  -moz-transform:    rotate(180deg);
  -ms-transform:     rotate(180deg);
  -o-transform:      rotate(180deg);
  transform:         rotate(180deg);
}


.section-header-icon-rotate {
  -webkit-transform: rotate(-180deg);
  -moz-transform:    rotate(-180deg);
  -ms-transform:     rotate(-180deg);
  -o-transform:      rotate(-180deg);
  transform:         rotate(-180deg);
}




@-moz-keyframes chevron-rotate { 100% { -moz-transform: rotate(180deg); } }
@-webkit-keyframes chevron-rotate { 100% { -webkit-transform: rotate(180deg); } }
@keyframes chevron-rotate { 100% { -webkit-transform: rotate(180deg); transform:rotate(180deg); } }

</style>
